// ギフティング画面 UI① 内の共有ヘルパ（W-D）。
import { ApiClientError } from "../../api/client";
import type { GfPaymentStatus, GfTab } from "../../types/gifting";

/** 例外 → 画面に出す日本語メッセージ */
export function errMsg(e: unknown): string {
  if (e instanceof ApiClientError) return e.message;
  if (e instanceof Error && e.message) return e.message;
  return "予期しないエラーが発生しました。";
}

export const PAYMENT_STATUS_LABEL: Record<GfPaymentStatus, string> = {
  none: "対象外",
  awaiting_invoice: "請求書待ち",
  invoice_received: "請求書受領",
  scheduled: "支払予定",
  paid: "支払済",
};

export const PAYMENT_STATUSES: readonly GfPaymentStatus[] = ["none", "awaiting_invoice", "invoice_received", "scheduled", "paid"];

export const GF_TABS: ReadonlyArray<{ key: GfTab; label: string }> = [
  { key: "dash", label: "ダッシュボード" },
  { key: "deals", label: "案件" },
  { key: "creators", label: "クリエイター" },
  { key: "ship", label: "発送" },
  { key: "rates", label: "報酬・料率" },
  { key: "assets", label: "素材庫" },
  { key: "sales", label: "営業" },
  { key: "settle", label: "精算・連携" },
];
